import produce from "immer";
import { IStoreState } from "../initialStoreState";

import { OpportunitesActions } from ".";
import { LoadState } from "../../constants/enums";
import { defaultOpportunity, defaultOpportunityState } from "./deafaultState";
import {
  CLEAR_OPPORTUNITES,
  CLEAR_OPPORTUNITES_STATE,
  FETCH_OPPORTUNITES_FAILED,
  FETCH_OPPORTUNITES_LIST_FAILED,
  FETCH_OPPORTUNITES_LIST_PROGRESS,
  FETCH_OPPORTUNITES_LIST_SUCCESS,
  FETCH_OPPORTUNITES_PROGRESS,
  FETCH_OPPORTUNITES_SUCCESS,
} from "./opportunitesActions";

export const opportunitesReducer = (
  state: IStoreState["opportunites"] = defaultOpportunityState,
  action: OpportunitesActions
) => {
  switch (action.type) {
    case FETCH_OPPORTUNITES_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
        draftState.list.data = [];
        draftState.list.error = null;
      });
      return newState;
    }
    case FETCH_OPPORTUNITES_LIST_SUCCESS: {
      const { data, totalRecords, currentRecords, meta } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.data = data;
        draftState.list.currentRecords = currentRecords;
        draftState.list.meta = meta;
        draftState.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_OPPORTUNITES_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_OPPORTUNITES_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.opportunity.loading = LoadState.InProgress;
        draftState.opportunity.data = defaultOpportunity;
        draftState.opportunity.error = null;
      });
      return newState;
    }
    case FETCH_OPPORTUNITES_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.opportunity.loading = LoadState.Loaded;
        draftState.opportunity.data = data;
      });
      return newState;
    }
    case FETCH_OPPORTUNITES_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.opportunity.loading = LoadState.Failed;
        draftState.opportunity.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_OPPORTUNITES: {
      const newState = produce(state, (draftState) => {
        draftState.opportunity.loading = LoadState.NotLoaded;
        draftState.opportunity.data = defaultOpportunity;
        draftState.opportunity.error = null;
      });
      return newState;
    }

    case CLEAR_OPPORTUNITES_STATE: {
      return defaultOpportunityState;
    }

    default: {
      return state;
    }
  }
};
